// src/services/demoService.js
import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  orderBy, 
  limit 
} from 'firebase/firestore';
import { db } from './firebase';

export class DemoService {
  // Submit a demo request to Firestore
  static async submitDemoRequest(demoData) {
    try {
      const docRef = await addDoc(collection(db, 'taskdata-demo-requests'), {
        ...demoData,
        status: 'pending',
        createdAt: new Date()
      });
      
      return {
        success: true,
        requestId: docRef.id,
        message: 'Demo request submitted successfully'
      };
    } catch (error) {
      console.error('Error submitting demo request:', error);
      throw new Error('Failed to submit demo request. Please try again.');
    }
  }

  // Get demo videos and content
  static async getDemoContent() {
    try {
      const q = query(
        collection(db, 'taskdata-demo-content'),
        where('isActive', '==', true),
        orderBy('sortOrder', 'asc')
      );
      
      const querySnapshot = await getDocs(q);
      const demoContent = [];
      
      querySnapshot.forEach(doc => {
        demoContent.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      return demoContent;
    } catch (error) {
      console.error('Error fetching demo content:', error);
      throw new Error('Failed to fetch demo content');
    }
  }

  // Get featured demo videos
  static async getFeaturedDemoVideos() {
    try {
      const q = query(
        collection(db, 'taskdata-demo-videos'),
        where('featured', '==', true),
        orderBy('sortOrder', 'asc'),
        limit(3)
      );
      
      const querySnapshot = await getDocs(q);
      const videos = [];
      
      querySnapshot.forEach(doc => {
        videos.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      return videos;
    } catch (error) {
      console.error('Error fetching demo videos:', error);
      throw new Error('Failed to fetch demo videos');
    }
  }

  // Get all demo videos by category
  static async getDemoVideosByCategory(category) {
    try {
      const q = query(
        collection(db, 'taskdata-demo-videos'),
        where('category', '==', category),
        orderBy('sortOrder', 'asc')
      );
      
      const querySnapshot = await getDocs(q);
      const videos = [];
      
      querySnapshot.forEach(doc => {
        videos.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      return videos;
    } catch (error) {
      console.error('Error fetching category videos:', error);
      throw new Error('Failed to fetch videos for this category');
    }
  }
}